import { inject, signal } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

export abstract class InputBase implements ControlValueAccessor {
  ngControl = inject(NgControl, { optional: true, self: true });
  value: unknown = '';
  isDisabled = signal(false);
  onChange: (value: unknown) => void = () => {
    return;
  };
  onTouched = () => {
    return;
  };

  constructor() {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  onBlur(): void {
    this.onTouched();
  }

  abstract writeValue(value: unknown): void;

  registerOnChange(fn: (s: unknown) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled.set(isDisabled);
  }

  get showErrors(): boolean {
    return this.ngControl
      ? this.ngControl.invalid! &&
          (this.ngControl.dirty! || this.ngControl.touched!)
      : false;
  }

  get errorMessage(): string {
    const errors = this.ngControl?.errors;

    if (!errors) return '';

    if (errors['maxlength']) {
      const maxLength = errors['maxlength'].requiredLength;
      return `Máximo de ${maxLength} caracteres permitidos`;
    }

    const messageKey = Object.keys(errors).find(key =>
      key.toLowerCase().includes('message'),
    );

    if (messageKey && errors[messageKey]) {
      const error = errors[messageKey];

      return error;
    }

    return '';
  }

  get control() {
    return this.ngControl?.control;
  }
}
